import styles from './Orbit.module.css';

type Props = {
  className?: string;
  height?: number;
  width?: number;
  children: React.ReactNode;
};

export function Orbit({ height = 170, children, ...props }: Props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 170" height={height} {...props}>
      <g opacity={0.5}>
        <circle
          cx={85}
          cy={85}
          r={84.5}
          stroke="var(--color-border-accent)"
          strokeLinecap="round"
          strokeDasharray="2 4.1"
        />
        <mask
          id="prefix__a"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x={85}
          y={0}
          width={85}
          height={170}
        >
          <path fill="#C4C4C4" d="M85 0h85v170H85z" />
        </mask>
        <g className={styles.Orbit_outerRing} mask="url(#prefix__a)">
          <circle cx={85} cy={85} r={84.5} stroke="var(--color-border-accent)" strokeLinecap="round" />
        </g>
      </g>
      <g opacity={0.75}>
        <circle
          cx={85}
          cy={85}
          r={55.92}
          fill="var(--color-border-accent)"
          fillOpacity={0.1}
          stroke="var(--color-border-accent)"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="3 6"
        />
        <mask
          id="prefix__b"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={85}
          height={170}
        >
          <path fill="#C4C4C4" d="M0 0h85v170H0z" />
        </mask>
        <g className={styles.Orbit_innerRing} mask="url(#prefix__b)">
          <circle
            cx={85}
            cy={85}
            r={55.92}
            stroke="var(--color-border-accent)"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <circle
        cx={85}
        cy={85}
        r={27.583}
        fill="var(--color-border-accent)"
        fillOpacity={0.1}
        stroke="var(--color-border-accent)"
        strokeWidth={1.5}
      />
      {children}
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(77 77)" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
